/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../../google/protobuf/any';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "api": {
            "nested": {
              "Error": {
                "fields": {
                  "category": {
                    "type": "squareup.cash.api.Error.Category",
                    "id": 1,
                    "rule": "optional"
                  },
                  "code": {
                    "type": "squareup.cash.api.Error.Code",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "field": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "retryable": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": "google.protobuf.Any",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Category": {
                    "values": {
                      "API_ERROR": 1,
                      "AUTHENTICATION_ERROR": 2,
                      "INVALID_REQUEST_ERROR": 3,
                      "RATE_LIMIT_ERROR": 4,
                      "PAYMENT_PROCESSING_ERROR": 5,
                      "MERCHANT_ERROR": 7,
                      "BRAND_ERROR": 8,
                      "DISPUTE_ERROR": 9,
                      "GRANT_ERROR": 10,
                      "API_KEY_ERROR": 11,
                      "WEBHOOK_ERROR": 12,
                      "ORDER_ERROR": 13,
                      "MESSAGE_ERROR": 14,
                      "OFFER_ERROR": 15,
                      "CUSTOMER_ERROR": 16,
                      "REQUEST_CHAINING_ERROR": 17,
                      "BANK_ACCOUNT_ERROR": 18
                    }
                  },
                  "Code": {
                    "values": {
                      "INTERNAL_SERVER_ERROR": 100,
                      "SERVICE_UNAVAILABLE": 101,
                      "GATEWAY_TIMEOUT": 102,
                      "UNAUTHORIZED": 200,
                      "ACCESS_TOKEN_REVOKED": 201,
                      "ACCESS_TOKEN_EXPIRED": 202,
                      "CLIENT_DISABLED": 203,
                      "FORBIDDEN": 204,
                      "INSUFFICIENT_SCOPES": 205,
                      "EXPECTED_JSON_BODY": 300,
                      "MISSING_REQUIRED_PARAMETER": 301,
                      "CONFLICTING_PARAMETERS": 302,
                      "UNKNOWN_QUERY_PARAMETER": 303,
                      "UNKNOWN_BODY_PARAMETER": 304,
                      "INVALID_CONTENT_TYPE": 305,
                      "MISSING_REGION": 306,
                      "INVALID_REGION": 307,
                      "FEATURE_DISABLED": 308,
                      "VERSION_MISMATCH": 309,
                      "EXPECTED_STRING": 400,
                      "VALUE_TOO_LONG": 401,
                      "VALUE_TOO_SHORT": 402,
                      "VALUE_EMPTY": 403,
                      "INVALID_ENUM_VALUE": 404,
                      "VALUE_REGEX_MISMATCH": 405,
                      "INVALID_TIME": 406,
                      "INVALID_EMAIL_ADDRESS": 407,
                      "INVALID_PHONE_NUMBER": 408,
                      "INVALID_URL": 409,
                      "FILE_TOO_LARGE": 410,
                      "FILE_EMPTY": 414,
                      "INVALID_WALLET_ADDRESS": 411,
                      "INVALID_BANK_ACCOUNT_NUMBER": 412,
                      "INVALID_BANK_IDENTIFICATION_NUMBER": 413,
                      "EXPECTED_INTEGER": 500,
                      "VALUE_TOO_HIGH": 501,
                      "VALUE_TOO_LOW": 502,
                      "EXPECTED_BOOLEAN": 600,
                      "EXPECTED_ARRAY": 700,
                      "ARRAY_LENGTH_TOO_LONG": 701,
                      "ARRAY_LENGTH_TOO_SHORT": 702,
                      "INVALID_ARRAY_TYPE": 703,
                      "ARRAY_CONTAINS_DUPLICATES": 704,
                      "EXPECTED_OBJECT": 800,
                      "NOT_FOUND": 900,
                      "CONFLICT": 901,
                      "INVALID_CURSOR": 902,
                      "IDEMPOTENCY_KEY_REUSED": 903,
                      "RATE_LIMITED": 904,
                      "INVALID_STATE_TRANSITION": 905,
                      "CLIENT_NOT_FOUND": 906,
                      "IDEMPOTENCY_PAYLOAD_MISMATCH": 907,
                      "MERCHANT_NOT_FOUND": 1000,
                      "PAYMENT_NOT_FOUND": 1001,
                      "REFUND_NOT_FOUND": 1002,
                      "CUSTOMER_DISABLED": 1003,
                      "MERCHANT_DISABLED": 1004,
                      "MERCHANT_PENDING": 1005,
                      "PAYMENT_DECLINED_COMPLIANCE": 1006,
                      "PAYMENT_DECLINED_INSUFFICIENT_FUNDS": 1007,
                      "PAYMENT_DECLINED_LIMIT_REACHED": 1008,
                      "PAYMENT_DECLINED_OTHER": 1009,
                      "PAYMENT_DECLINED_RISK": 1010,
                      "PAYMENT_INVALID_AMOUNT_MISMATCH": 1011,
                      "PAYMENT_INVALID_CURRENCY_MISMATCH": 1012,
                      "PAYMENT_INVALID_TOO_LARGE": 1013,
                      "PAYMENT_INVALID_TOO_SMALL": 1014,
                      "REFUND_DECLINED_COMPLIANCE": 1015,
                      "REFUND_DECLINED_OTHER": 1016,
                      "REFUND_DECLINED_RISK": 1017,
                      "REFUND_INVALID_AMOUNT_MISMATCH": 1018,
                      "REFUND_INVALID_CURRENCY_MISMATCH": 1019,
                      "REFUND_INVALID_PAYMENT_UNCAPTURED": 1020,
                      "REFUND_INVALID_TOO_LARGE": 1021,
                      "REFUND_INVALID_TOO_SMALL": 1022,
                      "PAYMENT_INVALID_SCOPE_MISMATCH": 1023,
                      "REFUND_INVALID_SCOPE_MISMATCH": 1024,
                      "MISSING_SETTLEMENT_CONFIGURATION": 1025,
                      "MISSING_REPORTING_CONFIGURATION": 1026,
                      "LIGHTNING_PAYMENT_NO_ROUTE_FOUND": 1027,
                      "LIGHTNING_INVOICE_EXPIRED": 1028,
                      "INCREMENTAL_AUTHORIZATION_DECLINED_ATTEMPT_LIMIT_REACHED": 1029,
                      "BRAND_NOT_FOUND": 1100,
                      "MERCHANT_MISSING_ADDRESS_OR_SITE": 1101,
                      "GRANT_ACTION_TYPE_MISMATCH": 1200,
                      "GRANT_CONSUMED": 1201,
                      "GRANT_EXPIRED": 1202,
                      "GRANT_NOT_FOUND": 1203,
                      "GRANT_REVOKED": 1204,
                      "DISPUTE_MISSING_EVIDENCE": 1300,
                      "API_KEY_INVALID_TOO_MANY": 1400,
                      "WEBHOOK_ENDPOINT_NOT_FOUND": 1500,
                      "WEBHOOK_ENDPOINT_TOO_MANY": 1501,
                      "CUSTOMER_UNSUPPORTED_REGION": 1600,
                      "CUSTOMER_NOT_VERIFIED": 1601,
                      "CUSTOMER_MISSING_INSTRUMENT": 1602,
                      "CUSTOMER_DELETED_ACCOUNT": 1603,
                      "TOO_FEW_MAP_ENTRIES": 1700,
                      "TOO_MANY_MAP_ENTRIES": 1701,
                      "INVALID_SUB_REQUEST_BODY": 1800,
                      "SUB_REQUEST_NOT_FOUND": 1801,
                      "ORDER_TOTAL_TOO_HIGH": 1900,
                      "ORDER_TOTAL_TOO_LOW": 1901,
                      "ORDER_LINE_ITEM_MISMATCH": 1902,
                      "BANK_ACCOUNT_DISABLED": 2000
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.api?.nested?.Error && !$root.nested?.squareup?.nested?.cash?.nested?.api?.nested?.Error?.nested?.Category && !$root.nested?.squareup?.nested?.cash?.nested?.api?.nested?.Error?.nested?.Code) {
  $root.addJSON(jsonData);
}

/**
 * Standard representation of an error plumbed through the Cash App Pay APIs.
 * Taken from the Square API Style Guide: https://plathome.sqprod.co/api-style-guide/rest#validations-errors
 *
 * SOURCE Error @ squareup/cash/api/errors.proto at 12:1
 */
export const Error = $root.lookupType('squareup.cash.api.Error');
fixType(Error);
Builder.createAndAttachToType(Error);
/**
 * A list of reasons why a request could fail, at a high level.
 *
 * SOURCE Category @ squareup/cash/api/errors.proto at 58:3
 */
Error.Category = $root.lookupEnum('squareup.cash.api.Error.Category').values;
/**
 * A list of detailed reasons why a request failed.
 *
 * SOURCE Code @ squareup/cash/api/errors.proto at 165:3
 */
Error.Code = $root.lookupEnum('squareup.cash.api.Error.Code').values;